import { User } from 'types';

export interface AuthState {
  user?: User;
  error?: Error;
  isLoggedIn: boolean;
  isGuestUser: boolean;
}

export interface AuthLogout {
  error?: Error;
  byUser?: boolean;
}

export const types = {
  auth: 'auth/login',
  signup: 'auth/signup',
  logout: 'auth/logout',
  ssoCallback: 'auth/ssoCallback',
  verifyCodes: 'auth/verifyCodes',
  checkEmailVerification: 'auth/checkEmailVerfication',
};
